import {streamify} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
@streamify('execute')
class GetSearchUpdateAdsUseCase extends UseCase {
  /**
   * @param {Object} params
   * @param {String} params.name
   * @param {Object} params.value
   * @return {Promise<Object, Error>} key value object
   */
  async execute({name, value} = {}) {
    return {name, value}
  }
}

export default GetSearchUpdateAdsUseCase
